import { useFormState } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { Trans } from '@lingui/react/macro'
import { GraphQL } from '@guestgoodie/graphql'

import { localesLabels } from '@/features/translations'
import { useTranslation } from './Translation'

export function Error({ name }: { name: string }) {
  const { errors } = useFormState()

  return (
    <ErrorMessage
      name={name}
      errors={errors}
      render={({ message }) => {
        return (
          <span className="pl-2 text-regular text-red-500" role="alert">
            {message}
          </span>
        )
      }}
    />
  )
}

export function TranslationError({
  name,
  locale
}: {
  name: string
  locale: GraphQL.AppLocale
}) {
  const { nameToErroredLocale } = useTranslation() ?? {}

  const erroredLocales = nameToErroredLocale?.[name]?.filter(l => l !== locale)

  if (!erroredLocales || erroredLocales.length === 0) return null

  const locales = localesLabels(erroredLocales).join(',')

  return (
    <span className="pl-2 text-regular text-red-500" role="alert">
      <Trans>Errors in {locales}</Trans>
    </span>
  )
}
